import angular from 'angular';

class ReloadServ {
  constructor($rootScope, $cookies, $route, $location, $interval, $cacheFactory) {
    this.cookies = $cookies;
    this.cacheFactory = $cacheFactory
    this.location = $location
    this.route = $route

    this.updateTabs = this.updateTabs.bind(this)
    this.watchCookie = this.watchCookie.bind(this)

    this.value = this.cookies.get('factbox_browser_message')
    
    $rootScope.$on('$destroy', () => {
      $interval.cancel(this.watchCookie);
    })
    $interval(this.watchCookie, 1000)
  }
  updateTabs() {
    this.browserUpdater = true;
    this.cookies.put('factbox_browser_message', new Date().getTime());
  }
  watchCookie() {
    let newValue = this.cookies.get('factbox_browser_message')
    if (!this.browserUpdater && newValue && newValue !== this.value) {
      this.value = newValue

      // Clear the cached user so the user object is refreshed
      this.cacheFactory.get('$http').remove('/user');
      // the auto-tab refresh should redirect to /home or /fact if the user
      // has a case selected, since a selected case in a background tab will
      // set the account to the previous account when switching accts. #84390466
      let path = this.route.current.originalPath
      if (/^\/home/.test(path) && !/signin/.test(path)) {

        this.location.search('redirect', '/home');
        this.location.path('/signin');

      } else if (/^\/fact/.test(path) && !/signin/.test(path)) {

        this.location.search('redirect', '/fact');
        this.location.path('/signin');

      } else {
        this.route.reload();
      }

    }
    this.browserUpdater = false;
  }
}

ReloadServ.$inject = ['$rootScope', '$cookies', '$route', '$location',
  '$interval', '$cacheFactory'
]

export default angular.module('services.reload', [])
  .service('ReloadServ', ReloadServ)
  .name;



// WEBPACK FOOTER //
// ./project/services/reload.js